import { useEventEmitter } from 'ahooks';
import { EventEmitter as AEventEmitter } from 'ahooks/lib/useEventEmitter';
import { createContext, useContext } from 'react';

export type EventEmitter = AEventEmitter<{
  type: 'CLICK_PUBLISH';
  payload?: {
    resolve?: (value: any) => void;
    reject?: (reason?: any) => void;
  };
}>;

export const EventEmitterContext = createContext<EventEmitter | null>(null);

export const EventEmitterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const eventEmitter = useEventEmitter<any>();
  return (
    <EventEmitterContext.Provider value={eventEmitter}>
      {children}
    </EventEmitterContext.Provider>
  );
};

export const useEventFromContext = () => {
  const context = useContext(EventEmitterContext);
  if (!context)
    throw new Error('Missing EventEmitterContext.Provider in the tree');
  return context;
};
